import React, { useState, useContext, useEffect } from 'react'
import {
    handleRedirectInternal,
    mapData,
    jsonToFormData,
    currencyFormat,
} from '../../Product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import PrimaryButton from '../../Product/components/atoms/PrimaryButton'
import AuthContext from '../../Product/context/auth/authContext'
import AlertContext from '../../Product/context/alert/alertContext'
import ProductContext from '../../Product/context/product/productContext'
import NoRecordsFound from '../../Product/components/atoms/NoRecordsFound'
import Loader from '../../assets/loader'
import moment from 'moment'
import { Pagination } from '@material-ui/lab'

const Redeem = () => {
    const authContext = useContext(AuthContext)
    const productContext = useContext(ProductContext)
    const validationArray = Yup.object({})
    const [regBtnLoading, setRegBtnLoading] = useState(false)
    const [listLoading, setListLoading] = useState(false)
    const [redeemsList, setRedeemList] = useState([])
    const [revardPoint, setRevardPoint] = useState(0)
    const [page, setPage] = useState(1)
    const { user, loadUser, isAuthenticated, active_plugins, getActivePlugins } = authContext
    const {
        redeemList,
        redeemPlugin,
        redeemListCount,
        redeemEnablelist,
        redeemEnableAPI,
        responseStatus,
    } = productContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const isPrimeBids = global.storeConfigration?.bodyClass?.value == 'primeBids'
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    const checkBidShopTheme = document.body.className == 'liquidationTwo bidShop'

    const formik = useFormik({
        initialValues: redeemPlugin?.reduce(
            (acc, item) => {
                acc[item.plan_name] = item.enable === 1
                return acc
            },
            {
                extended_pickup_days: false,
                free_item_bin_store: false,
                discount_applied_checkout: false,
            },
        ),
        validationSchema: validationArray,
    })

    const redeembox = global.pluginConfiguration?.reward_points?.access_key.range
        .filter((item) => item.redeem != 0)
        .map((item) => ({
            label: [item.name],
            name: item.from,
            type: 'checkbox_bid',
            class: 'col-md-12',
            formik: formik,
            disabled: redeemPlugin?.some(
                (redeemItem) => redeemItem.plan_name === item.from && redeemItem.enable === 1,
            ),
            onChange: () => {
                if (revardPoint < Number(item.to)) {
                    setAlert(`You need ${item.to} points to redeem. ${item.name}.`)
                } else {
                    const newValue = !formik.values[item.from]
                    formik.setFieldValue(item.from, newValue)
                    if (newValue) {
                        redeemEnableAPI({
                            site_id: global?.storeDetails?.site_id,
                            user_id: user.id,
                            name: item.name,
                            plugin_name: item.from,
                            amount: item.to,
                            redeem_value: item.redeem,
                        })
                        setRegBtnLoading(true)
                    }
                }
            },
        }))

    useEffect(() => {
        if (responseStatus && responseStatus !== '') {
            if (responseStatus.from === 'redeemEnableAPI') {
                redeemEnablelist({
                    site_id: global?.storeDetails?.site_id,
                    user_id: user.id,
                    page: page,
                    perlimit: 10,
                })
                setListLoading(true)
            }
        }
    }, [responseStatus])
    useEffect(() => {
        if (redeemList?.length > 0) {
            setRedeemList(redeemList)
            setListLoading(false)
            setRegBtnLoading(false)
            formik.setValues(
                redeemPlugin.reduce(
                    (acc, item) => {
                        acc[item.plan_name] = item.enable === 1
                        return acc
                    },
                    {
                        extended_pickup_days: false,
                        free_item_bin_store: false,
                        discount_applied_checkout: false,
                    },
                ),
            )
        } else {
            setListLoading(false)
            setRegBtnLoading(false)
        }
    }, [redeemList])
    useEffect(() => {
        setListLoading(true)
        const fetchRedeemList = async () => {
            if (user) {
                const res = await redeemEnablelist({
                    site_id: global?.storeDetails?.site_id,
                    user_id: user.id,
                    page: page,
                    perlimit: 10,
                })
                setRevardPoint(res.data.rewardpoint[0].reward_point)
                setListLoading(false)
            }
        }
        fetchRedeemList()
    }, [user])

    return (
        <div>
            {global.pluginConfiguration?.reward_points?.enable ? (
                listLoading ? (
                    ''
                ) : (
                    <div className="accChild">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="mp-head">
                                You currently have {revardPoint}{' '}
                                <i style={{ color: '#fcb444' }}>
                                    {checkBidShopTheme
                                        ? 'Points'
                                        : isPrimeBids
                                        ? 'Prime points!'
                                        : 'Rush points!'}
                                </i>
                            </h4>
                        </div>
                    </div>
                )
            ) : (
                ''
            )}
            {listLoading ? (
                ''
            ) : (
                <div>
                    <form className="">
                        {mapData(redeembox)}
                        <div className="makeStyles-root-20 undefined primButton false w-25 m-auto">
                            {/* <PrimaryButton
                            type="submit"
                            label={regBtnLoading ? 'Loading...' : 'Submit'}
                            disabled={regBtnLoading}
                        /> */}
                        </div>
                    </form>
                </div>
            )}
            {listLoading ? (
                <div className="text-center">
                    <Loader />
                </div>
            ) : redeemsList.length > 0 ? (
                <div className="table-responsive mt-4">
                    {
                        <table className="table table-hover mobile-table responisveTable">
                            <thead className="hidden-mobile">
                                <tr>
                                    {/* <th></th> */}
                                    {/* <th className="numCell" role="id">
                                        Id
                                    </th> */}
                                    <th role="Plan">Reward</th>
                                    <th role="Amount">Total Points</th>
                                    <th role="Status">Status</th>
                                    <th role="RedeemDate">Redeem Date</th>
                                </tr>
                            </thead>

                            <tbody>
                                {redeemsList.length !== 0 &&
                                    redeemsList.map((item, index) => {
                                        return (
                                            <>
                                                {item ? (
                                                    <tr key={index}>
                                                        {/* <td data-label="id">{item.id}</td> */}
                                                        <td data-label="Reward">{item?.name}</td>
                                                        <td data-label="Total Points">
                                                            {item?.amount}
                                                        </td>

                                                        <td data-label="status">
                                                            {item?.enable == 1
                                                                ? 'Active'
                                                                : 'Claimed'}
                                                        </td>

                                                        <td data-label="redeem-date">
                                                            {moment
                                                                .utc(item?.date_added)
                                                                .local()
                                                                .format('dddd, MMMM DD, YYYY')}
                                                        </td>
                                                    </tr>
                                                ) : null}
                                            </>
                                        )
                                    })}
                            </tbody>
                        </table>
                    }
                    <Pagination
                        count={Math.ceil(redeemListCount / 10)}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                    />
                </div>
            ) : isVarifiedGfTheme ? null : (
                <NoRecordsFound />
            )}
        </div>
    )
}

export default Redeem
